import { Navigate, useRoutes } from "react-router-dom";
// auth
import AuthGuard from "../auth/AuthGuard";
import GuestGuard from "../auth/GuestGuard";
// layouts
import CompactLayout from "../layouts/compact";
import DashboardLayout from "../layouts/dashboard";
// config
import RoleBasedGuard from "../auth/RoleBasedGuard";
import { PATH_AFTER_LOGIN } from "../config-global";
import FanChoiceDetail from "../pages/fanchoice/FanChoiceDetail";
import LandingPage from "../pages/LandingPage";
import LoginPage from "../pages/LoginPage";
import {
  AdminList,
  BannerList,
  BlogCategoryList,
  BlogList,
  ChampionList,
  Champions,
  CoachList,
  CreateAdmin,
  CreateBanner,
  CreateBlog,
  CreateChampion,
  CreateFanChoice,
  CreateFaq,
  CreateFeature,
  CreateGame,
  CreateKeyPerson,
  CreatePhoto,
  CreatePosition,
  CreateSeason,
  CreateSponsor,
  CreateSquad,
  CreateStadium,
  CreateTeam,
  CreateVerifiedCoach,
  CreateVerifiedPlayer,
  CreateVideoHub,
  EditPhoto,
  EditVideoHub,
  FanChoiceList,
  FanVoiceList,
  FaqList,
  FeatureCategoryList,
  FeatureList,
  GameDetail,
  GameList,
  KeyPersonList,
  LineUp,
  Page404,
  PhotoCategoryList,
  PhotoList,
  PlayerList,
  PositionList,
  Profile,
  SeasonList,
  Seasons,
  SponsorCategoryList,
  SponsorList,
  SquadList,
  StadiumList,
  Team,
  TeamList,
  TechnicalList,
  UsersList,
  VerifiedCoachList,
  VerifiedPlayerList,
  VideoCategoryList,
  VideoList,
  ViewBanner,
  ViewBlog,
  ViewEditAdmin,
  ViewEditCoach,
  ViewEditKeyPerson,
  ViewEditPlayer,
  ViewEditPosition,
  ViewEditSponsor,
  ViewEditStadium,
  ViewEditTechnical,
  ViewEditVerifiedCoach,
  ViewEditVerifiedPlayer,
  ViewFeature,
} from "./elements";

//

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: "/",
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        {
          path: "login",
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
      ],
    },

    {
      path: "/",
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
      ],
    },

    {
      path: "/admin",
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: "dashboard", element: <LandingPage /> },

        {
          path: "profile",
          element: <Profile />,
        },

        {
          path: "news",
          children: [
            { element: <Navigate to="/admin/news/" replace />, index: true },
            { path: "list", element: <BlogList /> },
            { path: "add", element: <CreateBlog /> },
            { path: "categories", element: <BlogCategoryList /> },
            {
              path: "view/:slug",
              element: <ViewBlog isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <ViewBlog isEdit={true} /> },
          ],
        },

        {
          path: "features",
          children: [
            {
              element: <Navigate to="/admin/features/" replace />,
              index: true,
            },
            { path: "list", element: <FeatureList /> },
            { path: "add", element: <CreateFeature /> },
            { path: "categories", element: <FeatureCategoryList /> },

            {
              path: "view/:slug",
              element: <ViewFeature isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <ViewFeature isEdit={true} /> },
          ],
        },

        {
          path: "banners",
          children: [
            {
              element: <Navigate to="/admin/banners/" replace />,
              index: true,
            },
            { path: "list", element: <BannerList /> },
            { path: "add", element: <CreateBanner /> },
            {
              path: "view/:slug",
              element: <ViewBanner isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <ViewBanner isEdit={true} /> },
          ],
        },
        {
          path: "videohub",
          children: [
            {
              element: <Navigate to="/admin/videohub/" replace />,
              index: true,
            },
            { path: "list", element: <VideoList /> },
            { path: "add", element: <CreateVideoHub /> },
            { path: "categories", element: <VideoCategoryList /> },

            {
              path: "view/:slug",
              element: <EditVideoHub isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <EditVideoHub isEdit={true} /> },
          ],
        },

        {
          path: "photo",
          children: [
            {
              element: <Navigate to="/admin/photo/" replace />,
              index: true,
            },
            { path: "list", element: <PhotoList /> },
            { path: "add", element: <CreatePhoto /> },
            { path: "categories", element: <PhotoCategoryList /> },
            {
              path: "view/:slug",
              element: <EditPhoto isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <EditPhoto isEdit={true} /> },
          ],
        },

        {
          path: "registration/player",
          children: [
            {
              element: <Navigate to="/admin/registration/player/" replace />,
              index: true,
            },
            { path: "list", element: <PlayerList /> },
            { path: "view/:slug", element: <ViewEditPlayer view={true} /> },
            { path: "edit/:slug", element: <ViewEditPlayer isEdit={true} /> },
          ],
        },

        {
          path: "registration/coach",
          children: [
            {
              element: <Navigate to="/admin/registration/coach/" replace />,
              index: true,
            },
            { path: "list", element: <CoachList /> },
            { path: "edit/:slug", element: <ViewEditCoach isEdit={true} /> },
            { path: "view/:slug", element: <ViewEditCoach view={true} /> },
          ],
        },

        {
          path: "registration/technical",
          children: [
            {
              element: <Navigate to="/admin/registration/technical/" replace />,
              index: true,
            },
            { path: "list", element: <TechnicalList /> },
            {
              path: "edit/:slug",
              element: <ViewEditTechnical isEdit={true} />,
            },
            { path: "view/:slug", element: <ViewEditTechnical view={true} /> },
          ],
        },

        {
          path: "registration/users",
          children: [
            {
              element: <Navigate to="/admin/registration/users/" replace />,
              index: true,
            },
            { path: "list", element: <UsersList /> },
          ],
        },

        {
          path: "verified/player",
          children: [
            {
              element: <Navigate to="/admin/verified/player/" replace />,
              index: true,
            },
            { path: "list", element: <VerifiedPlayerList /> },
            { path: "add", element: <CreateVerifiedPlayer /> },
            {
              path: "view/:slug",
              element: <ViewEditVerifiedPlayer isEdit={false} view={true} />,
            },
            {
              path: "edit/:slug",
              element: <ViewEditVerifiedPlayer isEdit={true} />,
            },
          ],
        },

        {
          path: "verified/coach",
          children: [
            {
              element: <Navigate to="/admin/verified/coach/" replace />,
              index: true,
            },
            { path: "list", element: <VerifiedCoachList /> },
            { path: "add", element: <CreateVerifiedCoach /> },
            {
              path: "view/:slug",
              element: <ViewEditVerifiedCoach view={true} isEdit={false} />,
            },
            {
              path: "edit/:slug",
              element: <ViewEditVerifiedCoach isEdit={true} />,
            },
          ],
        },

        {
          path: "verifiedcoach",
          children: [
            {
              element: <Navigate to="/admin/verifiedcoach/" replace />,
              index: true,
            },
            { path: "list", element: <CoachList /> },
            { path: "view/:slug", element: <ViewEditCoach view={true} /> },
          ],
        },

        // TODO: games
        {
          path: "games",
          children: [
            {
              element: <Navigate to="/admin/games/" replace />,
              index: true,
            },
            { path: "list", element: <GameList /> },
            { path: "add", element: <CreateGame /> },
            {
              path: "view/:slug",
              element: <GameDetail isEdit={false} view={true} />,
            },

            {
              path: "fan-voice/:slug",
              element: <FanVoiceList />,
            },

            {
              path: "lineup/:slug",
              element: <LineUp isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <GameDetail isEdit={true} /> },
          ],
        },

        // TODO: fan-choice
        {
          path: "fan-choice",
          children: [
            {
              element: <Navigate to="/admin/fan-choice/" replace />,
              index: true,
            },
            { path: "list", element: <FanChoiceList /> },
            { path: "add", element: <CreateFanChoice /> },
            {
              path: "edit/:id",
              element: <FanChoiceDetail isEdit={true} />,
            },

            {
              path: "lineup/:slug",
              element: <LineUp isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <GameDetail isEdit={true} /> },
          ],
        },

        // TODO: seasons
        {
          path: "settings/seasons",
          children: [
            {
              element: <Navigate to="/admin/settings/seasons/" replace />,
              index: true,
            },
            { path: "list", element: <SeasonList /> },
            { path: "add", element: <CreateSeason /> },
            {
              path: "view/:slug",
              element: <Seasons isEdit={false} view={true} />,
            },
            { path: "detail/:slug", element: <Seasons isEdit={true} /> },
          ],
        },

        // TODO: champions
        {
          path: "settings/champions",
          children: [
            {
              element: <Navigate to="/admin/settings/champions/" replace />,
              index: true,
            },
            { path: "list", element: <ChampionList /> },
            { path: "add", element: <CreateChampion /> },
            {
              path: "view/:slug",
              element: <Champions isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <Champions isEdit={true} /> },
          ],
        },

        // TODO: stadiums
        {
          path: "settings/stadiums",
          children: [
            {
              element: <Navigate to="/admin/settings/stadiums/" replace />,
              index: true,
            },
            { path: "list", element: <StadiumList /> },
            { path: "add", element: <CreateStadium /> },
            { path: "view/:slug", element: <ViewEditStadium isEdit={false} /> },
            { path: "edit/:slug", element: <ViewEditStadium isEdit={true} /> },
          ],
        },

        // TODO: key persons
        {
          path: "settings/keypersons",
          children: [
            {
              element: <Navigate to="/admin/settings/keypersons/" replace />,
              index: true,
            },
            { path: "list", element: <KeyPersonList /> },
            { path: "add", element: <CreateKeyPerson /> },
            {
              path: "view/:slug",
              element: <ViewEditKeyPerson isEdit={false} view={true} />,
            },
            {
              path: "edit/:slug",
              element: <ViewEditKeyPerson isEdit={true} view={false} />,
            },
          ],
        },

        // TODO: teams
        {
          path: "teams",
          children: [
            {
              element: <Navigate to="/admin/teams/" replace />,
              index: true,
            },
            { path: "list", element: <TeamList /> },
            { path: "add", element: <CreateTeam /> },
            {
              path: "view/:slug",
              element: <Team isEdit={false} view={true} />,
            },
            { path: "edit/:slug", element: <Team isEdit={true} /> },
            { path: "squad/:slug", element: <SquadList /> },
            { path: "add-squad/:slug", element: <CreateSquad /> },
            {
              path: "edit-squad/:slug",
              element: <CreateSquad isEdit={true} />,
            },
          ],
        },

        // TODO: positions
        {
          path: "settings/positions",
          children: [
            {
              element: <Navigate to="/admin/settings/positions/" replace />,
              index: true,
            },
            { path: "list", element: <PositionList /> },
            { path: "add", element: <CreatePosition /> },
            {
              path: "view/:slug",
              element: <ViewEditPosition isEdit={false} />,
            },
            { path: "edit/:slug", element: <ViewEditPosition isEdit={true} /> },
          ],
        },

        // TODO: sponsors

        {
          path: "sponsors",
          children: [
            {
              element: <Navigate to="/admin/sponsors/" replace />,
              index: true,
            },
            { path: "list", element: <SponsorList /> },
            { path: "add", element: <CreateSponsor /> },
            { path: "categories", element: <SponsorCategoryList /> },

            {
              path: "view/:slug",
              element: <ViewEditSponsor isEdit={false} view={true} />,
            },
            {
              path: "edit/:slug",
              element: <ViewEditSponsor isEdit={true} view={false} />,
            },
          ],
        },

        // TODO: user-management

        {
          path: "user-management",
          children: [
            {
              element: <Navigate to="/admin/user-management/" replace />,
              index: true,
            },
            { path: "list", element: <AdminList /> },
            { path: "add", element: <CreateAdmin /> },

            {
              path: "view/:slug",
              element: <ViewEditAdmin isEdit={false} view={true} />,
            },
            {
              path: "edit/:slug",
              element: <ViewEditAdmin isEdit={true} view={false} />,
            },
          ],
        },

        // TODO: squads
        {
          path: "squads",
          children: [
            {
              element: <Navigate to="/admin/squads/" replace />,
              index: true,
            },
            { path: "list", element: <SquadList /> },
            { path: "add", element: <CreateSquad /> },
            {
              path: "view/:slug",
              element: <ViewEditVerifiedPlayer isEdit={false} />,
            },
            {
              path: "edit/:slug",
              element: <ViewEditVerifiedPlayer isEdit={true} />,
            },
          ],
        },

        {
          path: "manage/faqs",
          element: (
            <RoleBasedGuard hasContent roles={["Administrator", "Super Admin"]}>
              <FaqList />
            </RoleBasedGuard>
          ),
        },

        {
          path: "manage/add-faqs",
          element: (
            <RoleBasedGuard hasContent roles={["Administrator", "Super Admin"]}>
              <CreateFaq />
            </RoleBasedGuard>
          ),
        },
      ],
    },
    {
      element: <CompactLayout />,
      children: [{ path: "404", element: <Page404 /> }],
    },

    // { path: "*", element: <Navigate to="/404" replace /> },
  ]);
}
